import React, { useState } from 'react';
import { loadGlobalSearchResult } from './constants/globalSearch';
import { sortByAlpha } from '../../helpers/sorters';
import { canWrite } from '../../helpers/rolePermissions';
import { loadingBlock } from '../../helpers/notifications';
import FormSubmissionsSearch from './FormSubmissionsSearch';

const ContainerSearchItem = ({ container, value, authorized }) => {
  const [forms, setForms] = useState([]);
  const [mailers, setMailers] = useState([]);
  const [userCanWrite, setUserCanWrite] = useState(false);
  const [hide, setHide] = useState(true);
  const [loading, setLoading] = useState(false);
  const showForms = forms.length > 0 && !hide;

  const handleFormLoad = async (container_id) => {
    let params = {
      id: container_id,
      value,
      form_ids: container.forms.map((f) => f.id),
    };
    setLoading(true);
    loadingBlock.add(`#expand-${container_id}`);
    let result = await loadGlobalSearchResult(params);
    if (result.ok) {
      setForms(sortByAlpha(result.data.forms, 'name'));
      setMailers(sortByAlpha(result.data.mailers, 'name'));
      setUserCanWrite(canWrite(result.data.user_permission));
      setHide(false);
    }
    if (result.status) {
      loadingBlock.remove(`#expand-${container_id}`);
      setLoading(false);
    }
  };

  return (
    <div className='container-search-item '>
      <h3>
        {container.name}{' '}
        {authorized ? (
          <div
            className='right'
            id={`expand-${container.id}`}
            onClick={
              forms.length === 0
                ? () => handleFormLoad(container.id)
                : () => setHide(!hide)
            }
            style={{ cursor: loading ? 'default' : 'pointer' }}
          >
            {hide ? (
              <i className='fa-solid fa-magnifying-glass-plus' title='Expand' />
            ) : (
              <i className='fa-solid fa-magnifying-glass-minus' title='Hide' />
            )}
            <span>{hide ? ' Expand ' : ''}</span>
          </div>
        ) : (
          <div className='right'>Unauthorized</div>
        )}
      </h3>
      <p>
        {container.forms.length} {container.forms.length > 1 ? 'Forms' : 'Form'}{' '}
        containing response "{value}"
      </p>
      {showForms &&
        forms.map((form) => (
          <FormSubmissionsSearch
            form={form}
            key={`f-${form.id}`}
            mailers={mailers.filter((m) => m.form_id == form.id)}
            userCanWrite={userCanWrite}
          />
        ))}
    </div>
  );
};

export default ContainerSearchItem;
